var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({minHeight: _vm.innerHeight + 'px'}),attrs:{"id":"app"}},[_c('za-layout',{scopedSlots:_vm._u([{key:"view",fn:function(){return [_c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }